import { type I18nLocale, t } from '@ardoq/i18n';

const WEEKDAY_KEYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'] as const;
const WEEKDAY_DEFAULTS = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];

export const getWeekDaysShortEu = (i18nLocale: I18nLocale): string[] =>
  WEEKDAY_KEYS.map((key, i) =>
    t(i18nLocale, `dateTimePicker:weekDaysShort.${key}`, WEEKDAY_DEFAULTS[i])
  );

export const getWeekDaysShortUs = (i18nLocale: I18nLocale): string[] => {
  const eu = getWeekDaysShortEu(i18nLocale);
  // EU starts Monday; US starts Sunday — rotate.
  return [eu[6], ...eu.slice(0, 6)];
};

const MONTH_KEYS = [
  'jan',
  'feb',
  'mar',
  'apr',
  'may',
  'jun',
  'jul',
  'aug',
  'sep',
  'oct',
  'nov',
  'dec',
] as const;
const MONTH_DEFAULTS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const getMonthNamesShort = (i18nLocale: I18nLocale): string[] =>
  MONTH_KEYS.map((key, i) =>
    t(i18nLocale, `dateTimePicker:monthsShort.${key}`, MONTH_DEFAULTS[i])
  );
